<template>
  <v-btn-toggle
    rounded
    :value="contractType"
    @change="handleChangeContractType"
  >
    <v-btn small value="sale">Venta</v-btn>
    <v-btn small value="rent">Renta</v-btn>
  </v-btn-toggle>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { CONTRACT_TYPE } from "./const";
export default {
  name: "ToogleContractType",
  computed: {
    ...mapState("properties", ["contractType"])
  },
  methods: {
    ...mapActions("properties", ["changeContractType"]),
    handleChangeContractType(value) {
      this.changeContractType(value || CONTRACT_TYPE.sale);
    }
  }
};
</script>
<style lang=""></style>
